export default __webpack_public_path__ + "static/media/family.512d8b7f.svg";